import { render, staticRenderFns } from "./SettingsSecurityCourseBank.vue?vue&type=template&id=c254560a&scoped=true"
import script from "./SettingsSecurityCourseBank.vue?vue&type=script&lang=js"
export * from "./SettingsSecurityCourseBank.vue?vue&type=script&lang=js"
import style0 from "./SettingsSecurityCourseBank.vue?vue&type=style&index=0&id=c254560a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c254560a",
  null
  
)

export default component.exports